<template>
  <div class="engineer-box">
    <div class="center-container">
      <div class="center-content">
        <el-table
          :data="tableData"
          class="table-container"
          :header-cell-style="getRowClass"
          v-loading="loading"
          border>
          <template slot="empty">
            <img class="empty" src="~assets/icon_none.png" alt="">
            <span class="empty-txt">{{empty}}</span>
          </template>
          <el-table-column
            prop="company_name"
            label="公司名称">
          </el-table-column>
          <el-table-column
            prop="cert_company"
            label="证书抬头">
          </el-table-column>
          <el-table-column
            prop="user_name"
            label="姓名">
          </el-table-column>
          <el-table-column
            prop="order_id"
            label="委托单号">
          </el-table-column>
          <el-table-column
            prop="amount"
            label="数量">
          </el-table-column>
          <el-table-column
            prop="create_date"
            label="创建日期">
          </el-table-column>
          <el-table-column label="操作" >
            <template slot-scope="scope">
              <el-button
                class="detail-btn"
                @click="handleApply(scope.row)"
                >
                详情
                </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script type='text/ecmascript-6'>
export default {
  data () {
    return {
      empty: '没有已领订单！',
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      sendShow: false,
      orderDetail: {},
      orderIndex: ''
    }
  },
  beforeCreate () { // 在创建实例之前 先 加载 加载框
    this.loading = true
  },
  created () {
    this.initData()
  },
  methods: {
    getRowClass({ rowIndex }) { // 设置表格第一行的颜色
      if (rowIndex == 0) {
        return 'background:#ECF0F8'
      } else {
        return ''
      }
    },
    initData () { // 初始化页面 发送 订单ID 获取订单详情
      let that = this
      this.$api.receiveOrder({
      }).then(res => {
        that.loading = false
        if (res.data.length > 0) {
          that.tableData = res.data
        } else {
          that.tableData = []
        }
      }).catch(err => {
        this.$message({
          message: err,
          type: 'error',
          customClass: 'msg-position',
          showClose: true
        })
      })
    },
    currentPageFun (page) {  // 点击 页码
      this.page = page
      this.initData()
    },
    handleApply (row) { // 点击详情
      this.orderDetail = row
      this.$router.push({
        path: '/receiveOrderDetail',
        query: { order_id: row.order_id}
      })
    }
  },
  components: {
  },
  watch: {
    /* '$router': 'initData' */
  }
}
</script>

<style  lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/mixin.styl'
.engineer-box
  overflow-y: auto;
  .center-container
    padding: 0rem 1rem 1rem 1rem;
    min-height:100%;
    .center-content
      background:#fff;
      padding: 1rem;
      .table-top
        margin-bottom:1rem;
        display:flex;
        justify-content: space-between;
        .new-btn
          width:4rem;
          height:1.6rem;
          padding:0;
          background: #1D489E;
          border-radius: 0.1rem;
          border:none;
          span
            color:#fff;
            font-size:0.7rem;
            i
              color:#fff;
        .send-btn
          width:4rem;
          height:1.6rem;
          padding:0;
          background: #48BEAA;
          border-radius: 0.1rem;
          border:none;
          span
            color: #fff;
        .search-input
          width:12rem;
          height:1.6rem;
          .el-input__inner
            border: 0.05rem solid #e5e6e7;
            border-radius: 1.6rem;
          .el-input__prefix
            .el-icon-search
              color: #C7C6CB
      .table-container.el-table
        th
          .cell
            font-size: 0.7rem;
            color: #404040;
        td
          .cell
            font-size:0.7rem;
            color:#666;
            .detail-btn
              background: #48beaa;
              border-radius: 0.2rem;
              height: 1.4rem;
              padding: 0 0.5rem;
              margin-left:0.5rem;
              border:none;
              span
                color:#fff;
            .edit-btn
              background: #48BEAA;
              border-radius: 0.2rem;
              height:1.4rem;
              padding: 0 0.5rem;
            .apply-btn
              background: #404040;
              border-radius: 0.01rem;
              height:1.4rem;
              padding: 0 0.5rem;
              /* width: 3.5rem; */
              span
                color: #fff;
              &.apply-btn.is-disabled
                opacity: 0.4;
        .el-table__empty-block
          min-height: 30rem;
          .el-table__empty-text
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .empty-txt
              color: #888;
      .page-container
        margin-top: 1rem;
        .el-pagination
          padding:0;
          .btn-prev
            margin-left:0px;
  .delete-container
    position:fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    background-color:rgba(0, 0, 0, 0.2);
    z-index:10000;
    display: flex;
    justify-content: center;
    align-items: center;
    .delete-content
      background:#fff;
      z-index: 100001;
      width: 20rem;
      padding: 2rem 0;
      border-radius: 0.4rem;
      position: relative;
      .delete-title
        text-align:center;
        font-size:0.8rem;
        .el-icon-warning
          color:red;
          font-size:1rem;
      .delete-txt
        text-align: center;
        margin-top:1rem;
        font-size:0.9rem;
        font-weight:medium;
        color:#666;
      .btn-container
        margin-top:1.5rem;
        padding: 0rem 2rem;
        width:100%;
        color: #666;
        box-sizing:border-box;
        display: flex;
        .btn-list
          flex:1;
          color:#fff;
          border:0;
          &.cancle-btn
            background: #cfcfcf;
            color:#fff;
            span
              color:#fff;
          &.sure-btn
            background: #EF757A;
            span
              color:#fff;
      .close-icon
        position: absolute;
        top:0.5rem;
        right:0.5rem;
        color:#9a9a9a;
        font-size:1.2rem;
</style>
